import { fetchJson } from '../base'

const taskBaseUrl = '/drs-serv/sys/task'

export function getExportTaskList(params) {
  return fetchJson(`${taskBaseUrl}/export/query`, params)
}

export function getImportTaskList(params) {
  return fetchJson(`${taskBaseUrl}/import/query`, params)
}

export function getExportTasksByIds(taskIds) {
  return fetchJson(`${taskBaseUrl}/export/selectByTaskIds`, { taskIds })
}



// WEBPACK FOOTER //
// ./src/api/system/task.api.js